import { z } from "zod";
export const employeeChoice = {
    MANUAL: "manual",
    AUTOMATIC: "automatic",
};
export const employeeChoiceSchema = z.enum(employeeChoice);
/**
 * Reserved top-level field on a review step's result: the employee's routing choice after
 * reviewing an escalated step. Its only workflow-agnostic consumer is `SequencingService`, which
 * records the `employeeChoice` decision gate when the field is present — hence optional here,
 * since a forced-review step may offer no choice. Review-capable step types `extend` this
 * fragment and may narrow the field to required.
 */
export const employeeChoiceResultSchema = z.object({
    employeeChoice: employeeChoiceSchema.optional(),
});
